import React from 'react';
import InfoBadge from '../../Elements/InfoBadge';
import WarningBadge from '../../Elements/WarningBadge';

function getNextFirstOfMonthAt23Utc() {
  const now = new Date();
  // Next 1st of month at 01:00 UTC
  let year = now.getUTCFullYear();
  let month = now.getUTCMonth(); // 0-based
  const thisMonthRun = new Date(Date.UTC(year, month, 1, 1, 0));
  if (now >= thisMonthRun) {
    month++;
    if (month > 11) {
      month = 0;
      year++;
    }
  }
  return new Date(Date.UTC(year, month, 1, 1, 0));
}

function formatLocalTime(utcDate) {
  return utcDate.toLocaleString([], {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

function getIobTargetMonthLabel(runDate) {
  // IOB processes the previous month relative to the run date
  const d = new Date(runDate);
  d.setUTCMonth(d.getUTCMonth() - 1);
  return `${d.getUTCFullYear()}/${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

function getFteAutoGenTargetMonthLabel(runDate) {
  // Auto FTE generation creates records for the run month (based on previous month's data)
  return `${runDate.getUTCFullYear()}/${String(runDate.getUTCMonth() + 1).padStart(2, '0')}`;
}

export default function FteIobWarnings({ warnings }) {
  if (!warnings) return null;

  const monthLabel = `${warnings.year}/${String(warnings.month).padStart(2, '0')}`;
  const nextRun = getNextFirstOfMonthAt23Utc();
  const localTime = formatLocalTime(nextRun);
  const iobMonth = getIobTargetMonthLabel(nextRun);
  const fteMonth = getFteAutoGenTargetMonthLabel(nextRun);

  return (
    <div className='d-flex align-items-center gap-3'>
      {warnings.notLockedCount > 0 && (
        <WarningBadge
          text={<><strong>{warnings.notLockedCount}</strong> not locked for <strong>{monthLabel}</strong>, lock before IOB generation</>}
        />
      )}
      <InfoBadge
        text={<>Next automated IOB generation for <strong>{iobMonth}</strong></>}
        secondaryText={localTime}
      />
      <InfoBadge
        icon='fa-solid fa-clone'
        text={<>Next automated FTE generation for <strong>{fteMonth}</strong></>}
        secondaryText={localTime}
      />
    </div>
  );
}
